'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'helmet-un';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e503';
var svgPathData = 'M240 32c114.9 0 208 93.1 208 208l0 16-192 0c-6.9 0-13 4.4-15.2 10.9L212.5 352 77.2 352c-25 0-45.2-20.2-45.2-45.2L32 240C32 125.1 125.1 32 240 32zm96 419.4l-93.6-88.1L267.5 288l68.5 0 0 163.4zM368 480l0-192 128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16C480 107.5 372.5 0 240 0S0 107.5 0 240l0 66.8C0 349.4 34.6 384 77.2 384l140.4 0L349 507.7c3 2.8 6.9 4.3 11 4.3l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zM285.3 103.1c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-43.2 34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 43.2-34.7-52zM160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHelmetUn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;